import { Flex } from "@radix-ui/themes";
import cx from "classnames";
import { type ComponentProps } from "react";

type PageHeaderProps = ComponentProps<"div">;

export function PageHeader({ children, className, ...rest }: PageHeaderProps) {
  return (
    <Flex
      align="center"
      gap="1"
      className={cx(
        "h-14 shrink-0 border-b border-puntt-neutral-gray-4 bg-base-white/90 px-5 backdrop-blur-sm",
        className,
      )}
      {...rest}
    >
      {children}
    </Flex>
  );
}
